module.exports = __webpack_public_path__ + "img/background.0397c71e.png";